import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const RoomTypeList = Loadable(
  lazy(() =>
    import("./RoomTypeList").then(({ RoomTypeList }) => ({
      default: RoomTypeList,
    })),
  ),
);

export const roomTypeRoutes = [
  {
    path: "/room-types",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.EVENT]}>
        <RoomTypeList />
      </AuthorizedRoute>
    ),
  },
];
